document.addEventListener('DOMContentLoaded', () => {
  const smallBtn = document.getElementById(
    'smallBtn'
  ) as HTMLAnchorElement | null;
  if (!smallBtn) return;

  const recommendBnr = document.getElementById(
    'recommendBnr'
  ) as HTMLAnchorElement | null;
  if (!recommendBnr) return;

  smallBtn.addEventListener('click', (e) => {
    e.preventDefault(); // リンクの場合はデフォルト動作を止める
    smallBtn.classList.toggle('small');
    recommendBnr.classList.toggle('small');
  });
});
